<template>
    <base-layout title="服务过程相关信息" :hideFooter="true">
        <template slot="main">
            <div class="page-body">
                <p>数据更新说明：部分数据可能存在同步延迟。</p>
                <ul>
                    <li v-for="(info,index) in dataList" :key="index">
                        <dl>
                            <dt>
                                {{ info.title }}
                            </dt>
                            <dd v-for="(item,index_two) in info.list" :key="index_two">
                                <strong>{{ item.name }}</strong>
                                <p @click="toPage(item.href)" :class="item.href !== undefined?'a':''">{{
                                        item.content
                                    }}</p>
                            </dd>
                        </dl>
                    </li>
                </ul>
            </div>
        </template>
    </base-layout>
</template>

<script>
// 页面布局组件
import baseLayout from "@comm/view/layout/baseLayout";
// app dataStore
import appStore from '@comm/store/app.store';
// 地址数据管理
import {getAddressList} from '@comm/store/address.store'

// 获取数据列表
function getDataList(isUseAddress, isExistOrder) {
    // 是否收集过地址
    return [
        {
            title: '订单记录',
            list: [
                {
                    name: '使用目的',
                    content: '用于订单交易履约'
                },
                {
                    name: '使用场景',
                    content: '使用点餐服务、购买商品时'
                },
                {
                    name: '收集情况',
                    content: isExistOrder ? '己收集' : '未收集',
                },
                {
                    name: '信息内容',
                    content: isExistOrder ? '我的订单' : '-',
                    href: isExistOrder ? '/order' : undefined,
                }
            ]
        },
        {
            title: '送餐地址及联系人信息',
            list: [
                {
                    name: '使用目的',
                    content: '用于订单交易履约'
                },
                {
                    name: '使用场景',
                    content: '添加和管理送餐地址及联系人信息时'
                },
                {
                    name: '收集情况',
                    content: isUseAddress ? '己收集' : '未收集',
                },
                {
                    name: '信息内容',
                    content: isUseAddress ? '地址列表' : '-',
                    href: isUseAddress ? '/address' : undefined,
                }
            ]
        }
    ]
}

export default {
    name: 'systemStatuteCollectionServiceProcessInfo',
    components: {
        // 页面布局组件
        baseLayout,
    },
    created() {
        // 获取地址列表
        getAddressList(true).then(addressList => {
            this.isUseAddress = /*appStore.getters.locationState &&*/ addressList.length;
            this.dataList = getDataList(this.isUseAddress, this.isExistOrder)
        }, err => {

        });
        // 查询用户是否下过单
        this.$service("isExistOrder")
            .success(isExistOrder => {
                this.isExistOrder = isExistOrder;
                this.dataList = getDataList(this.isUseAddress, this.isExistOrder)
            })
            .send();
    },
    data() {
        return {
            // 是否下过单
            isExistOrder: false,
            // 是否定位&有用户地址
            isUseAddress: false,
            dataList: getDataList(false, false)
        }
    },
    methods: {
        // 页面跳转
        toPage(href) {
            if (href) this.$router.push({path: href, query: {back: true}})
        }
    },
}
</script>

<style lang="scss" scoped>
.page-body {
    padding: 10px;
    height: 100%;
    overflow-y: scroll;
    position: relative;
    box-sizing: border-box;

    > p {
        color: gray;
        font-size: 12px;
        padding-bottom: 5px;
    }

    ul {
        li {
            padding-bottom: 10px;
        }
    }

    dl {
        padding: 10px;
        border-radius: 5px;
        background-color: #f7f7f7;
    }

    dt {
        font-size: 14px;
        font-weight: bold;
        padding-bottom: 5px;
    }

    dd {
        display: flex;
        position: relative;
        align-content: center;
        align-items: flex-start;
        justify-content: flex-start;
        min-height: 25px;

        strong {
            min-width: 60px;
            display: block;
            font-weight: normal;
        }

        p {
            flex: 1;
            display: flex;
            color: #999CA0;

            &.a {
                color: #2c4adc;
                text-decoration: underline;
            }
        }
    }
}
</style>